module.exports = __webpack_public_path__ + "img/logo.6794890e.svg";